import React from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { programSetupRedirectToList } from "actions";

const Header = () => {
  
  const dispatch = useDispatch();

  return (
    <>
      <div>
        <div className="d-flex justify-content-between align-items-center p-4">
          <h1 className="font-24 font-weight-s-bold m-0">Programs Setup</h1>
          <div className="d-flex align-items-center gap-3">
              <button className="c-b-btn" variant="none" onClick={() => { dispatch(programSetupRedirectToList()); }}>
                <img
                  className="me-2 add-user-icon"
                  src="/assets/images/close-icon.svg"
                  alt="Close"
                />
                Close
              </button>

            {/* Save Button */}
            
          </div>
        </div>
      </div>

    </>
  );
};

export default Header;
